
import { useState, useEffect } from 'react';
import Banner from './Banner';
import LoadingScreen from './LoadingScreen';
import HomeBanner from '../assets/home-banner.webp';
// import ProfileCard from './ProfileCard';
// import Leaderboard from './Leaderboard';
// import { userProfileData, leaderboardData } from '../mockData';
import { useAuth } from '../context/AuthContext';

const Home = () => {
  const [loading, setLoading] = useState(true);
  // const [profile, setProfile] = useState(null);
  // const [leaderboards, setLeaderboards] = useState({ global: [], weekly: [] });
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Simulate API delay  
        // await new Promise(resolve => setTimeout(resolve, 1000));

        // Set mock data  
        // setProfile(userProfileData);
        // setLeaderboards({
        //   global: leaderboardData.global,
        //   weekly: leaderboardData.weekly
        // });
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <LoadingScreen />;  
  }

  return (
    <div className="flex flex-col">
      <Banner />

      <img src={HomeBanner} alt="ZKcandy" />

      {/* <div className="flex-1 space-y-6">
        <div className="mt-2">
          {profile && <ProfileCard profile={profile} />}
        </div>

        <div className="space-y-4">
          <h2 className="section-title">Leaderboard</h2>
          <Leaderboard
            globalData={leaderboards.global}
            weeklyData={leaderboards.weekly}
          />
        </div>
      </div> */}
    </div>
  );
};

export default Home;  
